import { render, staticRenderFns } from "./logonstart.vue?vue&type=template&id=6d8f6730&scoped=true"
import script from "./logonstart.vue?vue&type=script&lang=js"
export * from "./logonstart.vue?vue&type=script&lang=js"
import style0 from "./logonstart.vue?vue&type=style&index=0&id=6d8f6730&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8f6730",
  null
  
)

export default component.exports